(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tw-subscribe"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-subscribe')) {
    class TwSubscribe extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.tw-sub__input');
        this.planInput = this.querySelector('input[name="selling_plan"]');
        this.root = this.closest('.shopify-section') || document;

        this.checkbox.addEventListener('change', this.onToggle);
        this.root.addEventListener('change', this.onPackChange);
        if (this.checkbox.checked) this.onToggle();
      }

      disconnectedCallback() {
        this.root.removeEventListener('change', this.onPackChange);
      }

      onToggle = () => {
        this.planInput.disabled = !this.checkbox.checked;
        if (!this.checkbox.checked) return;

        const firstPack = this.root.querySelector(`.variant-bundle__input[data-variant-id="${this.dataset.variantId}"]`);
        if (firstPack && !firstPack.checked) firstPack.click();
      };

      onPackChange = (event) => {
        const pack = event.target;
        if (!(pack instanceof HTMLInputElement) || !pack.matches('.variant-bundle__input')) return;
        if (pack.dataset.variantId === this.dataset.variantId) return;

        this.checkbox.checked = false;
        this.planInput.disabled = true;
      };
    }

    customElements.define('tw-subscribe', TwSubscribe);
  }
  } catch(e) { console.error(e); }
})();

})();
